function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "9ac4a",
  d: "M1407 48v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2"
}), React.createElement("path", {
  id: "9ac4b",
  d: "M1395 34a4 4 0 1 1 8 0 4 4 0 0 1-8 0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-1391 -30)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 2,
  xlinkHref: "#9ac4a"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#fff",
  fillOpacity: 0,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 50,
  strokeWidth: 2,
  xlinkHref: "#9ac4b"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/profile.16a82687.svg";
export { SvgComponent as ReactComponent };